import * as React from "react";
import { Box } from "@material-ui/core";
import { themeVariables } from "../_Theme";

import * as styles from "./styles.scss";

interface IProps {
  name: string;
  href?: string;
  disabled?: boolean;
}

export const CourseCardName = (props: IProps) => {
  const textColor = props.disabled
    ? themeVariables.palette.grey[500]
    : themeVariables.palette.grey[50];

  const label = (
    <Box
      component="span"
      className={styles.cardBodyCoursename}
      color={textColor}
    >
      {props.name}
    </Box>
  );

  return (
    <Box
      p={1.5}
      clone={!!props.href}
      display="block"
      className={styles.cardBodyCoursenameWrap}
    >
      {props.href ? (
        <a href={props.href} title={props.name}>
          {label}
        </a>
      ) : (
        label
      )}
    </Box>
  );
};
